import { Chip } from '@mui/material';
import { ReferralStatus, RewardStatus } from './types';

export const ReferralStatusChip = ({ status }: { status: ReferralStatus }) => {
  const map: Record<ReferralStatus, { bg: string; color: string }> = {
    Qualified:   { bg: '#E8F5E9', color: '#2E7D32' },
    Registered:  { bg: '#E3F2FD', color: '#1565C0' },
    Inactive:    { bg: '#FDECEA', color: '#C62828' },
  };
  const s = map[status] ?? { bg: '#F5F5F5', color: '#616161' };
  return (
    <Chip
      label={status}
      size="small"
      sx={{ backgroundColor: s.bg, color: s.color, fontWeight: 600, fontSize: '0.75rem' }}
    />
  );
};

export const RewardStatusChip = ({ status }: { status: RewardStatus }) => {
  if (status === '-') return <>-</>;
  const map: Record<Exclude<RewardStatus, '-'>, { bg: string; color: string }> = {
    Claimed:     { bg: '#E8F5E9', color: '#2E7D32' },
    'Not Claimed': { bg: '#FFF3E0', color: '#E65100' },
  };
  const s = map[status as Exclude<RewardStatus, '-'>] ?? { bg: '#F5F5F5', color: '#616161' };
  return (
    <Chip
      label={status}
      size="small"
      sx={{ backgroundColor: s.bg, color: s.color, fontWeight: 600, fontSize: '0.75rem' }}
    />
  );
};
